// extracted by mini-css-extract-plugin
export default {"headerLeftSide":"_8MakK","headerTop":"_3ocdQ","linkWrapper":"_21a90","link":"_2DCSa","name":"xDp4t","bulletSeparator":"_28hU_","timeAgo":"_3De5T","badge":"ulM_C"};